import { useState, useEffect } from "react";
const cachedScripts = [];

export default function useKlashaScript(
  isTestMode = false,
) {
  let src1 = "https://main.d3r485nqo1ffyt.amplifyapp.com/pay.js";

  const isAlreadyLoaded = typeof window !== "undefined" && Boolean(window.KlashaClient);

  const [state, setState] = useState({
    loaded: isAlreadyLoaded,
    error: false,
  });

  useEffect(() => {
    if (typeof window !== "undefined" && window.KlashaClient) {
      if (!cachedScripts.includes(src1)) cachedScripts.push(src1);
      setState({
        loaded: true,
        error: false,
      });
      return;
    }

    if (cachedScripts.includes(src1)) {
      setState({
        loaded: true,
        error: false,
      });
    } else {
      let divScript = window.document.getElementById("ktest");
      if (!divScript) {
        divScript = window.document.createElement("div");
        divScript.id = "ktest";
        window.document.body.appendChild(divScript);
      }

      const script1 = document.createElement("script");
      script1.src = src1;
      script1.async = true;

      const onScriptLoad = () => {
        if (!cachedScripts.includes(src1)) cachedScripts.push(src1);
        setState({
          loaded: true,
          error: false,
        });
      };

      const onScriptError = () => {
        const index1 = cachedScripts.indexOf(src1);
        if (index1 >= 0) cachedScripts.splice(index1, 1);
        script1.remove();

        setState({
          loaded: true,
          error: true,
        });
      };

      script1.addEventListener("load", onScriptLoad);
      script1.addEventListener("complete", onScriptLoad);
      script1.addEventListener("error", onScriptError);

      document.body.appendChild(script1);

      return () => {
        script1.removeEventListener("load", onScriptLoad);
        script1.removeEventListener("error", onScriptError);
      };
    }
  }, [src1]);

  return [state.loaded || Boolean(typeof window !== "undefined" && window.KlashaClient), state.error];
}
